// URL base para arquivos de mídia (/media/...). Mesmo critério do api.js:
// 1. No navegador (Web): mesma origem em que o sistema foi aberto (domínio/IP atual)
// 2. No app Mobile/Emulador: IP da VPS atual
const getMediaBaseUrl = () => {
    if (typeof window !== 'undefined' && window.location) {
        const { hostname, origin } = window.location;
        const isNative = Boolean(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
        if (!isNative && hostname && hostname !== 'localhost' && hostname !== '127.0.0.1' && !origin.includes('localhost:3000') && /^https?:/i.test(origin)) {
            return origin;
        }
    }
    return 'http://184.107.156.47:3015';
};

export const MEDIA_BASE_URL = getMediaBaseUrl();
export default MEDIA_BASE_URL;
